import type { IndicatorRegistryEntry } from "lightweight-charts-indicators"
import { CloseIcon, EyeIcon, EyeOffIcon, GearIcon, TrashIcon } from "../../ui/icons.tsx"
import type { IndicatorInstance } from "../workspace/workspaceStore.ts"

/** TradingView's toolbar for a selected indicator: settings, hide, remove. */
export function IndicatorFloatingToolbar({ entry, instance, onClose, onOpenSettings, onRemove, onToggle }: {
  readonly entry: IndicatorRegistryEntry
  readonly instance: IndicatorInstance
  readonly onOpenSettings: () => void
  readonly onToggle: () => void
  readonly onRemove: () => void
  readonly onClose: () => void
}) {
  return (
    <div className="floating-toolbar" onPointerDown={(event) => event.stopPropagation()}>
      <span className="floating-title">{entry.name}</span>
      <button type="button" title="Settings" onClick={onOpenSettings}>
        <GearIcon />
      </button>
      <button type="button" title={instance.hidden ? "Show" : "Hide"} onClick={onToggle}>
        {instance.hidden ? <EyeOffIcon /> : <EyeIcon />}
      </button>
      <button type="button" title="Remove" onClick={onRemove}>
        <TrashIcon />
      </button>
      <span className="floating-divider" />
      <button type="button" title="Deselect" onClick={onClose}>
        <CloseIcon />
      </button>
    </div>
  )
}
